"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = exports.failLoadEvents = exports.deleteMatchFromFavoriteLocal = exports.deleteMatchFromFavoriteRequest = exports.addRehydrateMatchesToFavorite = exports.addMatchToFavoriteLocal = exports.addMatchToFavoriteRequest = exports.initFavoriteLocal = exports.getFavoriteEventsByIds = exports.getFavoriteEventsIds = void 0;
var core_1 = __importDefault(require("@gin-betting/core"));
var match_list_1 = __importDefault(require("@gin-betting/match-list"));
var constants_1 = require("./constants");
var makeGetMatchesByEventIds = core_1.default.entities.actions.makeGetMatchesByEventIds;
var GET_FAVORITE_MATCHES_REQUEST = match_list_1.default.constants.GET_FAVORITE_MATCHES_REQUEST;
var makeAction = core_1.default.utils.makeAction;
var getFavoriteEventsIds = function (variables) {
    if (variables === void 0) { variables = {}; }
    return {
        type: constants_1.GET_FAVORITE_EVENT_IDS_REQUEST,
        payload: {
            method: 'getFavoriteSportEventsIds',
            variables: variables,
        },
        meta: { isApiCall: true },
    };
};
exports.getFavoriteEventsIds = getFavoriteEventsIds;
exports.getFavoriteEventsByIds = makeGetMatchesByEventIds({
    type: GET_FAVORITE_MATCHES_REQUEST,
    withMarketsCount: true,
});
var initFavoriteLocal = function (payload) {
    return makeAction(constants_1.INIT_FAVORITE_LIST_LOCAL, payload);
};
exports.initFavoriteLocal = initFavoriteLocal;
var addMatchToFavoriteRequest = function (_a) {
    var favoriteId = _a.favoriteId;
    var variables = {
        ids: [favoriteId],
    };
    return {
        type: constants_1.ADD_FAVORITE_MATCH_REQUEST,
        payload: {
            method: 'addFavoriteSportEvents',
            variables: variables,
            args: {
                favoriteId: favoriteId,
            },
        },
        meta: { isApiCall: true },
    };
};
exports.addMatchToFavoriteRequest = addMatchToFavoriteRequest;
var addMatchToFavoriteLocal = function (payload) {
    return makeAction(constants_1.ADD_FAVORITE_MATCH_LOCAL, payload);
};
exports.addMatchToFavoriteLocal = addMatchToFavoriteLocal;
var addRehydrateMatchesToFavorite = function (variables, args) {
    return {
        type: constants_1.ADD_REHYDRATE_FAVORITE_MATCHES_REQUEST,
        payload: {
            method: 'addFavoriteSportEvents',
            variables: variables,
            args: args,
        },
        meta: { isApiCall: true },
    };
};
exports.addRehydrateMatchesToFavorite = addRehydrateMatchesToFavorite;
var deleteMatchFromFavoriteRequest = function (_a) {
    var favoriteId = _a.favoriteId;
    var variables = {
        ids: [favoriteId],
    };
    return {
        type: constants_1.REMOVE_FAVORITE_MATCH_REQUEST,
        payload: {
            method: 'deleteFavoriteSportEvents',
            variables: variables,
            args: {
                favoriteId: favoriteId,
            },
        },
        meta: { isApiCall: true },
    };
};
exports.deleteMatchFromFavoriteRequest = deleteMatchFromFavoriteRequest;
var deleteMatchFromFavoriteLocal = function (payload) { return makeAction(constants_1.REMOVE_FAVORITE_MATCH_LOCAL, payload); };
exports.deleteMatchFromFavoriteLocal = deleteMatchFromFavoriteLocal;
var failLoadEvents = function () { return makeAction(constants_1.GET_FAVORITE_EVENT_IDS_FAIL); };
exports.failLoadEvents = failLoadEvents;
exports.Actions = {
    getFavoriteEventsIds: exports.getFavoriteEventsIds,
    // getFavoriteEventsByIds,
    initFavoriteLocal: exports.initFavoriteLocal,
    failLoadEvents: exports.failLoadEvents,
    addMatchToFavoriteRequest: exports.addMatchToFavoriteRequest,
    addMatchToFavoriteLocal: exports.addMatchToFavoriteLocal,
    addRehydrateMatchesToFavorite: exports.addRehydrateMatchesToFavorite,
    deleteMatchFromFavoriteRequest: exports.deleteMatchFromFavoriteRequest,
    deleteMatchFromFavoriteLocal: exports.deleteMatchFromFavoriteLocal,
};
//# sourceMappingURL=actions.js.map